export const numberWord = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];

const relatedGuideKey = 'related_guide';

const relatedGuideNames = numberWord.slice(0, 6).map((n) => ({
  description: `${relatedGuideKey}_description_${n}`,
  thumbnail: `${relatedGuideKey}_image_${n}`,
  title: `${relatedGuideKey}_title_${n}`,
  url: `${relatedGuideKey}_url_${n}`,
}));

export const generateSimilarArticlesData = (wpData: any) => {
  if (wpData) {
    const contentData = relatedGuideNames.map((n) => ({
      description: wpData[n.description],
      thumbnail: wpData[n.thumbnail],
      title: wpData[n.title],
      url: wpData[n.url],
    }));
    return {
      contentArea: contentData,
      ctaText: wpData[`${relatedGuideKey}_cta_text`],
      ctaUrl: wpData[`${relatedGuideKey}_cta_url`],
      header: wpData[`${relatedGuideKey}_header`],
    };
  }
  return null;
};
